import React from "react"
import services from "../data/services"
import Entry from "../components/Entry"
import ScrollAnimation from 'react-animate-on-scroll';

function createServices(service) {
  return (
    <Entry
      key={service.id}
      name={service.name}
      description={service.description}
      icon={service.icon}
    />
  );
}

const Services = () => (
  <div className="row" id="services" style={{color:"white"}}>
    <div className="services">
      <p className="align-middle" style={{color:"#ff4a57"}}>SERVICES</p>
      <h2 className="align-middle" style={{color:"#fff"}}><b>My Services</b></h2>
      <ScrollAnimation
        animateIn="fadeInLeft"
        animateOnce="true"
        duration={1.7}
        delay={0}
      >
      <div className="row myservices-container animated fadeInLeft">
        {services.map(createServices)}
      </div>
      </ScrollAnimation>
    </div>
  </div>
)

export default Services
